import { Route } from '@angular/router';
import {
  CheckoutAccountGuard,
  CheckoutGuard,
  CmsRouteResolver,
  HomeRouteGuard,
} from '@boels/shared-state';

export const homeRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: ':culture/branches',
        canActivate: [HomeRouteGuard],
        loadChildren: () =>
          import('./store-finder.routes').then((m) => m.storeFinderRoutes),
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/cart',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.ContentTemplateRendererComponent,
          ),
        canActivate: [HomeRouteGuard],
        resolve: {
          resolvedData: CmsRouteResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/checkout/:checkoutStep',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.ContentTemplateRendererComponent,
          ),
        canActivate: [CheckoutGuard],
        resolve: {
          resolvedData: CmsRouteResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: ':culture/checkout-account',
        loadComponent: () =>
          import('@boels/components').then(
            (c) => c.ContentTemplateRendererComponent,
          ),
        canActivate: [CheckoutAccountGuard],
        resolve: {
          resolvedData: CmsRouteResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
      {
        path: '**',
        loadComponent: () =>
          import('@boels/components').then(
            (m) => m.ContentTemplateRendererComponent,
          ),
        canActivate: [HomeRouteGuard],
        resolve: {
          resolvedData: CmsRouteResolver,
        },
        runGuardsAndResolvers: 'pathParamsChange',
        data: {
          defaultReuseStrategy: false,
          resetReuseStrategy: true,
        },
      },
    ],
  },
];
